module.exports = __webpack_public_path__ + "img/2019homepark-3.6cd67400.jpeg";